export default "__VITE_ASSET__6fad7bf7__"